import { StepData } from '@/lib/Steppers';
import { ConnectorFlowDTO, ConnectorDirection } from '@/models/connectors';

export const SOURCE_CONNECTOR_WIZARD_DIRECTION: ConnectorDirection = 'INPUT';

export const filterSourceConnectorWizardFlows = (flows: ConnectorFlowDTO[]) =>
  flows.filter((flow) => flow.kind === SOURCE_CONNECTOR_WIZARD_DIRECTION || !flow.kind);

export enum CREATE_DATA_SOURCE_SOURCE_CONNECTOR {
  CONNECTOR = 'CONNECTOR',
  ENTITY = 'ENTITY',
  PREVIEW = 'PREVIEW',
  MAP_COLUMNS = 'MAP_COLUMNS',
  CONFIRMATION = 'CONFIRMATION',
}

export const CREATE_DATA_SOURCE_SOURCE_CONNECTOR_STEPS: ReadonlyArray<StepData<string>> = [
  { id: CREATE_DATA_SOURCE_SOURCE_CONNECTOR.CONNECTOR, title: 'data_sources:wizard.source_connector.steps.connector' },
  { id: CREATE_DATA_SOURCE_SOURCE_CONNECTOR.ENTITY, title: 'data_sources:wizard.source_connector.steps.entity' },
  { id: CREATE_DATA_SOURCE_SOURCE_CONNECTOR.PREVIEW, title: 'data_sources:wizard.source_connector.steps.preview' },
  { id: CREATE_DATA_SOURCE_SOURCE_CONNECTOR.MAP_COLUMNS, title: 'data_sources:wizard.source_connector.steps.mapping' },
  { id: CREATE_DATA_SOURCE_SOURCE_CONNECTOR.CONFIRMATION, title: 'data_sources:wizard.source_connector.steps.confirmation' },
];

export const D365_BC_SYNC_LOGICAL_KEY = 'D365_BC_SYNC';
